import { createSelectors } from "@/redux/helpers/selector";

import { MODULE } from "./constants";

export const [
  getPayments,
  getInvoiceTotal,
  getTotalPaid,
  getBalanceDue,
  getFetchStatus,
  getRecordStatus,
  getDeleteStatus,
  getIsRecordModalOpen,
  getDeleteTarget,
  getPaymentStatus,
  getPaymentMethodOptions,
  getPaymentAccountOptions,
  getPartialInvoices,
  getOrderTotal,
  getOrderOutstandingBalance,
  getRestoreStatus,
  getRestoreError,
  getDeleteError,
] = createSelectors(MODULE, [
  "payments",
  "invoiceTotal",
  "totalPaid",
  "balanceDue",
  "fetchStatus",
  "recordStatus",
  "deleteStatus",
  "isRecordModalOpen",
  "deleteTarget",
  "paymentStatus",
  "paymentMethodOptions",
  "paymentAccountOptions",
  "partialInvoices",
  "orderTotal",
  "orderOutstandingBalance",
  "restoreStatus",
  "restoreError",
  "deleteError",
]);
